import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, SectionHead, Modalites, DevisCta, Btn } from "@/components/Shared";

export default function FormationLayout({
  seoTitle,
  seoDesc,
  path,
  kicker,
  title,
  subtitle,
  dureeBadge,
  publicCible,
  objectifs,
  programme,
  duree,
  prerequis,
  alert,
}) {
  return (
    <div data-testid={`page-${path.replaceAll("/", "-")}`}>
      <Seo title={seoTitle} description={seoDesc} path={path} />
      <PageHero
        kicker={kicker}
        title={title}
        subtitle={subtitle}
        badge={
          <div className="flex flex-wrap gap-2">
            <span className="font-sans font-semibold text-xs px-4 py-1.5 rounded-full bg-vert/10 border border-vert text-vert">
              Durée indicative : {dureeBadge}
            </span>
            <span className="font-sans font-semibold text-xs px-4 py-1.5 rounded-full bg-white/10 border border-white/30 text-white/85">
              {publicCible}
            </span>
          </div>
        }
      />

      {alert && (
        <section className="bg-white pt-14">
          <div className="max-w-4xl mx-auto px-6">{alert}</div>
        </section>
      )}

      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="font-serif text-3xl text-marine mb-8">Objectifs de la formation</h2>
          <ul className="space-y-4">
            {objectifs.map((o) => (
              <li key={o} className="flex gap-3 font-sans text-base text-marine/85 leading-relaxed">
                <CheckCircle2 className="text-vert-dark shrink-0 mt-0.5" size={20} />
                {o}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-sable py-16">
        <div className="max-w-4xl mx-auto px-6">
          <SectionHead kicker="Programme" title="Un programme construit pour la pratique." center={false} />
          <div className="space-y-6">
            {programme.map((m, i) => (
              <div
                key={m.titre}
                data-testid={`module-${i + 1}`}
                className="bg-white border border-bordure rounded-lg p-7 flex gap-6"
              >
                <p className="font-serif text-[44px] text-vert/30 leading-none shrink-0">0{i + 1}</p>
                <div>
                  <h3 className="font-serif text-xl text-marine mb-2">{m.titre}</h3>
                  <p className="font-sans text-[15px] text-gris-texte leading-relaxed">{m.texte}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="font-sans text-sm text-gris-texte italic mt-8">
            Programme indicatif : chaque action est conçue sur mesure après diagnostic de votre
            besoin. Programme détaillé communiqué sur demande.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <Modalites duree={duree} prerequis={prerequis} />
          <div className="text-center mt-12">
            <Btn to="/contact" testid="formation-cta-devis" variant="primary">
              Demander un devis pour cette formation
            </Btn>
          </div>
        </div>
      </section>

      <DevisCta title="Un besoin, une équipe, un projet ?" />
    </div>
  );
}
